import constate from "constate";
import { useCallback } from "react";
import { addHours, getTime, isValid } from "date-fns";
import { fromStorage, storePrefix, toStorage } from "./storage/makeStorageHook";

export const usePendingReads = ({ store }: { store: Storage }) => {
  const calculateTimeout = (date: Date) =>
    isValid(date) ? getTime(addHours(date, 2)) : undefined;

  const addPendingRead = useCallback(
    (id: string, now: Date) => {
      store.setItem(storePrefix(id), toStorage(now, calculateTimeout(now)));
    },
    [store],
  );

  const getPendingRead = useCallback(
    (id: string) => {
      try {
        return fromStorage(store.getItem(storePrefix(id)), () => {
          store.removeItem(storePrefix(id));
        });
      } catch (err) {
        console.error(err);
        return null;
      }
    },
    [store],
  );

  return {
    addReading: addPendingRead,
    getReading: getPendingRead,
  };
};

export const [PendingMeterReadProvider, usePendingMeterReadContext] = constate(
  usePendingReads,
);
